module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/3/1-279960a13131e3fe0d3f523160f14916.jpg";